function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M92.6 0h-8.2c-1.1 0-2.1 1.4-2.1 2.5s1 2.5 2.1 2.5h7.2C93.8 5 95 6.2 95 8.4V31H5V8.4C5 6.2 7.6 5 9.7 5h58.1c1.1 0 2-1.3 2-2.5 0-1.1-.9-2.5-2-2.5h-59C4.5 0 0 2.9 0 7.4v83.8c0 4.5 4.5 8.8 8.8 8.8h83.8c4.3 0 7.4-4.3 7.4-8.8V7.4c0-4.5-3.1-7.4-7.4-7.4zm-1.8 95h-80C8.6 95 5 92.9 5 90.3V37h90v53.2c0 2.8-1.4 4.8-4.2 4.8z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M79.1 47H54c-1.2 0-2.2 1.3-2.2 2.5s1 2.5 2.2 2.5h25.2c1.2 0 2.2-1.3 2.2-2.5-.1-1.2-1.1-2.5-2.3-2.5zM79 68c1.2 0 2.2-.8 2.2-2s-1-2-2.2-2H53.8c-1.2 0-2.2.8-2.2 2s1 2 2.2 2H79zM79.1 80H19.9c-1.2 0-2.2.8-2.2 2s1 2 2.2 2h59.3c1.2 0 2.2-.8 2.2-2-.1-1.2-1.1-2-2.3-2zM19.9 16c-1.2 0-2.2 1.3-2.2 2.5s1 2.5 2.2 2.5h4c1.2 0 2.2-1.3 2.2-2.5s-1-2.5-2.2-2.5h-4zM32.7 16c-1.2 0-2.2 1.3-2.2 2.5s1 2.5 2.2 2.5h4c1.2 0 2.2-1.3 2.2-2.5s-1-2.5-2.2-2.5h-4zM19.6 68h17c.1 0 .2.1.2.1 1.2 0 2.2-1 2.2-2.2V49.2c0-1.2-1-2.2-2.2-2.2h-.2H19.9h.1c-1.2 0-2 1-2 2.2v16.7c0 1.1.6 1.9 1.6 2.1zM35 64H22V51h13v13z"
});

var SvgMenuVdp = function SvgMenuVdp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2);
};

export default SvgMenuVdp;